
import { supabase } from './client';
import { mockAttendees } from '@/utils/demoDataGenerator';

// Create direct table structure for attendees without inserting test data
export const createAttendeesTable = async () => {
  console.log('Checking if attendees table exists...');
  try {
    // Check if table exists by querying it
    const { data, error } = await supabase
      .from('attendees')
      .select('id')
      .limit(1);
    
    if (!error) {
      console.log('Attendees table already exists!');
      return true;
    }
    
    // If table doesn't exist, create it with minimal schema check
    console.log('Table may not exist, attempting to create schema check...');
    const { error: createError } = await supabase
      .from('attendees')
      .select('id')
      .limit(0);
    
    if (!createError) {
      console.log('Table creation confirmed!');
      return true;
    } else {
      console.error('Error confirming attendees table:', createError);
      return false;
    }
  } catch (err) {
    console.error('Exception checking attendees table:', err);
    return false;
  }
};

// Create direct table structure for admin_actions - making sure to use snake_case column names
export const createAdminActionsTable = async () => {
  console.log('Checking if admin_actions table exists...');
  try {
    // Check if table exists by querying it
    const { data, error: checkError } = await supabase
      .from('admin_actions')
      .select('action_id')
      .limit(1);
      
    if (!checkError) {
      console.log('Admin actions table already exists!');
      return true;
    }
    
    // Table may not exist, try a minimal schema check
    console.log('Table may not exist, attempting to create schema check...');
    const { error: createError } = await supabase
      .from('admin_actions')
      .select('action_id')
      .limit(0);
    
    if (!createError) {
      console.log('Admin actions table creation confirmed!');
      return true;
    } else {
      console.error('Error confirming admin_actions table:', createError);
      return false;
    }
  } catch (err) {
    console.error('Exception checking admin_actions table:', err);
    return false;
  }
};

// Create direct table structure for admin_state - modified to check existence without inserting
export const createAdminStateTable = async () => {
  console.log('Checking if admin_state table exists...');
  try {
    // Check if table exists by querying it
    const { data, error } = await supabase
      .from('admin_state')
      .select('id')
      .limit(1);
    
    if (!error) {
      console.log('Admin state table already exists!');
      return true;
    }
    
    // Table may not exist, try a minimal schema check
    console.log('Table may not exist, attempting to create schema check...');
    const { error: createError } = await supabase
      .from('admin_state')
      .select('id')
      .limit(0);
    
    if (!createError) {
      console.log('Admin state table creation confirmed!');
      return true;
    } else {
      console.error('Error confirming admin_state table:', createError);
      return false;
    }
  } catch (err) {
    console.error('Exception checking admin_state table:', err);
    return false;
  }
};
